import React from 'react'

const OutboxIcon = () => {
	return (
		<svg width={20} height={28} viewBox='0 0 20 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g fill='currentColor'>
				<path d='M9.999 17.477a.845.845 0 00.594-.242.821.821 0 00.245-.585V2.83l2.893 2.846a.846.846 0 001.188 0 .822.822 0 000-1.17L10.593.241a.841.841 0 00-.594-.243.85.85 0 00-.594.243L5.079 4.505a.822.822 0 000 1.171.846.846 0 001.188 0L9.16 2.83v13.82c0 .22.089.43.246.585a.846.846 0 00.594.242z' />
				<path d='M19.158 9.4h-4.653a.846.846 0 00-.594.242.821.821 0 000 1.17.846.846 0 00.594.242h3.814v15.291H1.679v-15.29h3.814a.846.846 0 00.593-.243.821.821 0 000-1.17.846.846 0 00-.593-.243H.84a.846.846 0 00-.594.243.821.821 0 00-.246.585v16.945c0 .22.088.43.246.585A.846.846 0 00.84 28h18.318a.846.846 0 00.594-.242.821.821 0 00.246-.585V10.226c0-.22-.089-.43-.246-.585a.846.846 0 00-.594-.243z' />
			</g>
			<defs>
				<clipPath id='clip0'>
					<path fill='currentColor' d='M0 0H20V28H0z' />
				</clipPath>
			</defs>
		</svg>
	)
}

export default OutboxIcon
